import { render, staticRenderFns } from "./PromotionTarget.vue?vue&type=template&id=5bf9c77c&"
import script from "./PromotionTarget.vue?vue&type=script&lang=ts&"
export * from "./PromotionTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports